import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import tokenDecoder from 'src/utils/tokenDecoder';
export default {
    getAllGroups,
    getFactoriesByGroupID,
    getDivisionDetailsByEstateID,
    GetArrearsDetails,
    getEstateNameByEstateID,
    getRoutesForDropDown,
    CheckISBalancePaymentCompleted,
    GetBalancePaymentEstimationBeforeBalanncePayementRun,
    GetBalancePaymentYearMonth
}
async function getAllGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups');
    let groupArray = [];
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
};

async function getFactoriesByGroupID(groupID) {
    var factoryArray = [];
    const response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] == true) {
            factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
        }
    }
    return factoryArray;
}

async function getDivisionDetailsByEstateID(estateID) {
    let response = await CommonGet('/api/Division/getDivisionDetailsByEstateID', "estateID=" + parseInt(estateID));
    let divisionArray = [];
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["divisionID"]] = item[1]["divisionName"];
    }
    return divisionArray;
};

async function GetArrearsDetails(arrearsReportInputModel) {
    let response = await CommonPost('/api/ArrearsReport/GetArrearsReportDetails', null, arrearsReportInputModel);
    return response;
    
}

async function getEstateNameByEstateID(estateID) {
    let response = await CommonGet('/api/DenominationReport/GetEstateNameByEstateID', "estateID=" + parseInt(estateID));
    return response.data;
};

async function getRoutesForDropDown(estateID) {
    var routeArray = [];
  
    const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + estateID)
    for (let item of Object.entries(response.data)) {
      routeArray[item[1]["routeID"]] = item[1]["routeName"]
    }
    return routeArray;
}

async function CheckISBalancePaymentCompleted(groupID, estateID) {
  let response = await CommonGet('/api/BalancePayment/CheckISBalancePaymentCompletedInEstateID', 'groupID=' + groupID + '&estateID=' + estateID)
  return response;
}

async function GetBalancePaymentEstimationBeforeBalanncePayementRun(collectionTypeBalanceRateModel) {
  let model = {
    ...collectionTypeBalanceRateModel,
    createdBy: tokenDecoder.getUserIDFromToken(),
  }
  let response = await CommonPost('/api/ArrearsReport/GetBalancePaymentEstimationBeforeBalanncePayementRun', null, model);
  return response;
}

async function GetBalancePaymentYearMonth(groupID, factoryID) {
  let response = await CommonGet('/api/BalancePaymentYearMonth/GetBalancePaymentYearMonth', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
};